import styled from 'styled-components'
import Typography from '~components/dumbs/Typography'
import Button from '~components/dumbs/Button'

export const SecondaryTypography = styled(Typography).attrs({ as: 'h3' })`
  color: ${({ theme }) => theme.neutral.text.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  line-height: 48px;
  padding-left: ${({ theme }) => theme.spacing.km6};
  padding-right: ${({ theme }) => theme.spacing.km6};
  text-align: center;
`

export const SecondaryButton = styled(Button)`
  white-space: nowrap;
  margin-right: ${({ theme }) => theme.spacing.km2};
`
